/* eslint-disable no-use-before-define */

/* eslint-disable no-unused-vars */

/* eslint-disable @typescript-eslint/no-unused-vars */
import React from "react";
import {
  Animated,
  StyleProp,
  ViewStyle,
  TextStyle,
} from "react-native";
import SVG_Svg, {
  G as SVG_G,
  Path as SVG_Path,
  GProps,
  PathProps,
} from "react-native-svg";
/* SVGR has dropped some elements not supported by react-native-svg: desc */

/***/

const Path = Animated.createAnimatedComponent<
  React.ComponentClass<
    PathProps & {
      style?: StyleProp<ViewStyle>;
    }
  >
>(SVG_Path);
const G = Animated.createAnimatedComponent<
  React.ComponentClass<
    GProps & {
      style?: StyleProp<ViewStyle>;
    }
  >
>(SVG_G);
const Svg = Animated.createAnimatedComponent(SVG_Svg);

/*
 * -------------------------------------------------------------------------
 *
 *  /$$$$$$                                /$$$$$$$  /$$
 * |_  $$_/                               | $$__  $$| $$
 *   | $$   /$$$$$$/$$$$   /$$$$$$        | $$  \ $$| $$ /$$   /$$  /$$$$$$
 *   | $$  | $$_  $$_  $$ /$$__  $$       | $$$$$$$ | $$| $$  | $$ /$$__  $$
 *   | $$  | $$ \ $$ \ $$| $$  \ $$       | $$__  $$| $$| $$  | $$| $$$$$$$$
 *   | $$  | $$ | $$ | $$| $$  | $$       | $$  \ $$| $$| $$  | $$| $$_____/
 *  /$$$$$$| $$ | $$ | $$| $$$$$$$/  /$$  | $$$$$$$/| $$|  $$$$$$/|  $$$$$$$
 * |______/|__/ |__/ |__/| $$____/  |__/  |_______/ |__/ \______/  \_______/
 *                       | $$
 *                       | $$
 *                       |__/
 *
 * -------------------------------------------------------------------------
 *
 * ORIGINAL SVG
 * ---------------------------------
 * <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"> <desc id="IMP.BLUE"></desc>
 * <g id="CancelIcon">
 * <path id="Rectangle 378" opacity="0.71" d="M0 2C0 0.89543 0.895431 0 2 0H19C20.1046 0 21 0.895431 21 2V19C21 20.1046 20.1046 21 19 21H2C0.89543 21 0 20.1046 0 19V2Z" fill="white"/>
 * <g id="Vector">
 * <path fill-rule="evenodd" clip-rule="evenodd" d="M16.8461 18L3 3.83558L3.81589 3.00094L17.662 17.1654L16.8461 18Z" fill="black"/>
 * <path fill-rule="evenodd" clip-rule="evenodd" d="M18 3.83465L4.15388 17.9991L3.33799 17.1644L17.1841 3L18 3.83465Z" fill="black"/>
 * </g>
 * </g>
 * </svg>
 *
 * ---------------------------------
 *
 * CONFIGURATION
 * ---------------------------------
 * {}
 * ---------------------------------
 *
 * DESCRIPTION
 * ---------------------------------
 * No description provided!
 * ---------------------------------
 */

/** Component Properties Interface */
export type tProps = {
  style?: tStyle;
  svgStyle?: tStyle;
  isInsideScrollView?: boolean;
  svgRef?: () => void;
  onAnimationComplete?: () => void;
};
/***/

/***/

export type tStyle = StyleProp<ViewStyle>;
export type tTextStyle = StyleProp<TextStyle>;
/***/

/***/

/**
 * Auto-Generated Imp.Blue Component based on your design!
 * @param {tProps} props Developer interface to the component!
 * @returns {JSX.Element} JSX
 *
 * Description --
 * No description provided!
 */

export const CancelIcon = (props: {
  style?: tStyle;
  svgStyle?: tStyle;
  isInsideScrollView?: boolean;
  svgRef?: () => void;
  onAnimationComplete?: () => void;
}): JSX.Element => {
  const {
    svgRef,
  } = props;
  /** End Custom React-Hooks */

  /** Component Render (Javascript-React Markup) */

  return (
    <Svg viewBox="0 0 21 21" fill="none" id="svg_root" ref={svgRef} {...props}>
      <G id="CancelIcon">
        <Path
          id="Rectangle_20378"
          opacity={0.71}
          d="M0 2C0 0.89543 0.895431 0 2 0H19C20.1046 0 21 0.895431 21 2V19C21 20.1046 20.1046 21 19 21H2C0.89543 21 0 20.1046 0 19V2Z"
          fill="white"
          strokeWidth="1"
          vectorEffect="non-scaling-stroke"
        />
        <G id="Vector">
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.8461 18L3 3.83558L3.81589 3.00094L17.662 17.1654L16.8461 18Z"
            fill="black"
            id="Vector_elem0"
            strokeWidth="1"
            vectorEffect="non-scaling-stroke"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18 3.83465L4.15388 17.9991L3.33799 17.1644L17.1841 3L18 3.83465Z"
            fill="black"
            id="Vector_elem1"
            strokeWidth="1"
            vectorEffect="non-scaling-stroke"
          />
        </G>
      </G>
    </Svg>
  );
};
/***/

export default React.memo(CancelIcon);
